<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-page-header @back="goBack" :content="'审核对账单'"></el-page-header>
        <el-form label-position="right" :model="item" label-width="auto">
            <el-form-item label="所属供应商">
                <el-select v-model="item.industryId" filterable placeholder="请选择">
                    <el-option
                            v-for="item in options"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="对账单编号">
                <el-input v-model="item.number" placeholder="请输入对账单编号"></el-input>
            </el-form-item>
            <el-form-item label="对账单金额">
                <el-input v-model="item.fee" placeholder="请输入对账单金额"></el-input>
            </el-form-item>
            <el-form-item label="状态">
                <el-radio v-model="status" label="1">待审核</el-radio>
                <el-radio v-model="status" label="2">已审核</el-radio>
            </el-form-item>
			<el-form-item>
                    <el-button size="big" type="primary" @click="checkSubmit">保存</el-button>
</el-form-item>
            <el-form-item>
                <el-dialog
                        title="提示"
                        :visible.sync="dialogVisible"
                        width="30%"
                        >
                    <span>您确认保存嘛</span>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="dialogVisible = false">取 消</el-button>
                        <el-button type="primary" @click="submit">确 定</el-button>
                    </span>
                </el-dialog>
             </el-form-item>
        </el-form>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                item: {},
                isLoad: false,
                id: this.$route.query.id,
                token: localStorage.token,
                dialogVisible: false,
                options: [
                    {
                        id:'1',
                        name:'蒙牛集团'
                    },{
                        id:'2',
                        name:'gongys'
                    },{
                        id:'3',
                        name:'厦门点微信息'
                    },{
                        id:'4',
                        name:'软件园独家代理'
                    }],
                status:'1'
            }
        },
        created() {
            this.item = {
                id: 1,
                industryId: 1,
                name: '蒙牛集团',
                number: '1',
                fee: '100.00'
            }
            // this.loadData()
        },
        methods: {
            loadData: function () {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                this.axios.post('/admin/industry/list', {}).then(res => {
                    res.data.records.forEach((item) => {
                        this.options.push(item)
                    })
                }).then(res => {
                    if (this.id) {
                        return this.axios.post('/admin/industry/template/detail', {
                            id: this.id
                        })
                    }
                }).then(res => {
                    this.isLoad = !this.isLoad
                    if(res){
                        // item是基础信息
                        this.item = res.data
                    }
                }).catch(() => {
                    this.isLoad = !this.isLoad
                })
            },
            // 后退一步
            goBack() {
                this.$router.back(-1)
            },
            // 提交
            submit() {
                return;
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                let url = ''
                if (this.id) {
                    url = '/admin/industry/template/update'
                    this.item.id = this.id
                } else {
                    url = '/admin/industry/template/add'
                }
                this.axios.post(url, this.item)
                    .then(() => {
                        this.isLoad = !this.isLoad
                        this.$message.success({
                            message: '保存成功'
                        });
                        this.goBack()
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            uploadError() {
                this.$message.error({
                    message: '上传失败'
                });
            }
        }
    }
</script>
<style scoped>
</style>·